import React, { useEffect } from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import { useQuill } from 'react-quilljs';
import s from 'quill/dist/quill.snow.css';
import t from '../../../styles/customQuillEditor.css'

let Editor = (props) => {
	const { quill, quillRef } = useQuill({
		modules: {
			toolbar: [
				[{ 'header': 1 }, { 'header': 2 }, { 'header': 3 }],
				[{ 'size': ['small', false, 'large', 'huge'] }],
				['bold', 'italic', 'underline', 'strike'],
				[{ 'list': 'ordered' }, { 'list': 'bullet' }],
				[{ 'indent': '-1' }, { 'indent': '+1' }],
				['link']
			],
		},
	});

	useEffect(() => {
		if (quill) {
			quill.clipboard.addMatcher(Node.ELEMENT_NODE, (node, delta) => {
				delta.ops.forEach(op => {
					if (op.attributes) {
						console.log("op", op);
						delete op.attributes.color;
						delete op.attributes.background;
					}
				});
				return delta;
			});
			quill.clipboard.dangerouslyPasteHTML(props.value);
			quill.on('text-change', (delta, oldDelta, source) => {
				props.onChange(quill.root.innerHTML)
				if (quill.getText() == '') {
					props.onChange('<p> </p>');
				}
			});
		}
	}, [quill]);

	return (
		<div className='commonQuillBox'>
			<div ref={quillRef} />
		</div>
	);
};

Editor = withStyles(s, t)(Editor);
export { Editor }
